export const STEPS = {
  MODE: 'mode',
  AUTO_QTY: 'autoQty',
  AUTO_AGENT: 'autoAgent',
  AUTO_TYPE: 'autoType',
  MANUAL_SECTION: 'manualSection',
  MANUAL_LOCALITY: 'manualLocality',
  MANUAL_QTY: 'manualQty',
  MANUAL_AGENT: 'manualAgent',
};

export const AUTO_TYPES = [
  { value: 0, label: 'FIFO' },
  { value: 1, label: 'LIFO' },
  { value: 2, label: 'بیشترین موجودی سلول' },
  { value: 3, label: 'کمترین موجودی سلول' },
];

export const stepTitles = {
  [STEPS.MODE]: 'نوع برداشت را انتخاب کنید',
  [STEPS.AUTO_QTY]: 'درخواست برداشت',
  [STEPS.AUTO_AGENT]: 'درخواست برداشت',
  [STEPS.AUTO_TYPE]: '',
  [STEPS.MANUAL_LOCALITY]: 'انتخاب محل موجودی',
  [STEPS.MANUAL_QTY]: 'درخواست برداشت',
  [STEPS.MANUAL_AGENT]: 'درخواست برداشت',
};
